<template>
  <v-chip v-bind="$attrs" :class="getTextColor()">
    <slot />
  </v-chip>
</template>

<script>
export default {
  name: "PtChip",
  methods: {
    getTextColor() {
      if (this.$attrs.color.endsWith("200")) {
        let textColor = this.$attrs.color.replace("200", "800");
        if (textColor) return textColor + "--text";
        else return "";
      } else return "";
    }
  }
};
</script>

<style scoped lang="scss">
.v-chip {
  text-transform: capitalize;
}
</style>
